import { render, staticRenderFns } from "./AlfApproverList.vue?vue&type=template&id=7b0baa35"
import script from "./AlfApproverList.vue?vue&type=script&lang=js"
export * from "./AlfApproverList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports